import App from '@/layouts/App';
import RestrictedDashboardLayout from '@/layouts/Dashboard/RestrictedDashboardLayout';
import useAuthStore from '@pkg/auth/useStore';
import hasRoleFor from '@pkg/entities/users/access/hasRoleFor';
import withAuth from '@/lib/auth/withAuth';
import { OrganisationRole } from '@/lib/enums';
import DashboardContainer from '@/components/DashboardContainer/DashboardContainer';

const DashboardPage = () => {
  const me = useAuthStore((state) => state.me);
  const organisation = useAuthStore((state) => state.organisation);

  const isAdmin = hasRoleFor(me, OrganisationRole.ADMIN, organisation);
  const isRestricted = !isAdmin && organisation.is_restricted;

  return (
    <App
      fullWidth
      pageId="dashboard"
      metaTitle="Dashboard"
      heading="My dashboard"
      noHeader={isRestricted}
      breadcrumbs={{
        crumbs: [{ label: 'Dashboard', pathname: '/dashboard' }],
        current: 'Current',
      }}
    >
      {!isAdmin && <RestrictedDashboardLayout />}
      {isAdmin && <DashboardContainer />}
    </App>
  );
};

export default withAuth(DashboardPage);
